import React from 'react';
import { Box, Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { FormattedMessage, useIntl } from 'react-intl';
import { H1, H2, P } from '@osmosis/tailwind-ui/components/Text';
import {
  LocalizedQuizLoggedOutItems,
  quizLoggedOutBannerItems,
  quizLoggedOutBannerItemsArray,
  QuizLoggedOutItems,
} from '../../constants/formatMesage';
import CelebrateImage from '../../assets/celebrate.png';
import { useUserContext } from '../../context/UserContext';

/**
 * Quiz logged out banner.
 */
const QuizLoggedOutBanner = ({
  isVisible,
  learnName,
}: {
  isVisible: boolean;
  learnName: string;
}) => {
  const intl = useIntl();
  const { user } = useUserContext();

  if (user) {
    return null;
  }

  const topic = learnName
    .replace(/_/g, ' ')
    .replace(/%2C/g, ',')
    .split('%3A')[0];

  const localizedLoggedOutBannerItems: LocalizedQuizLoggedOutItems =
    quizLoggedOutBannerItems(intl);

  return (
    <Flex
      className={`${
        isVisible ? '' : 'max-lg:hidden '
      }relative w-full bg-primary-800`}
    >
      <Flex
        className="absolute w-full h-full"
        style={{
          opacity: 0.1,
          background: `url(${CelebrateImage.src}) center/cover`,
        }}
      />
      <Flex
        className={`w-full py-[22px] px-[42px] max-lg:px-0 justify-between max-lg:justify-center`}
      >
        <Box className={'w-full max-w-[60%] max-lg:text-center pr-4'}>
          <H1 className="text-white sm:text-[24px] max-sm:text-[18px] mb-[12px]">
            <FormattedMessage
              defaultMessage="{topic} Quiz: Ace Your Exams"
              values={{ topic: topic }}
              id="loggedout_quiz_banner.title"
            />
          </H1>
          <P className="max-lg:hidden text-white text-[16px]">
            <FormattedMessage
              defaultMessage="Get ready to dominate your medical and nursing exams by using our dynamic quizzes to elevate your knowledge and increase your confidence. Whether you're gearing up for the USMLE®, COMLEX®, or your next in-class assessment, Osmosis quizzes tackle key topics in pathology, diagnostics, and treatment approaches. By honing in on clinical readiness and decision-making, we make sure the knowledge you gain empowers you both in the classroom and in real-world practice. Jump in and supercharge your exam prep!"
              id="loggedout_quiz_banner.description"
            />
          </P>
        </Box>
        <Box className="max-lg:hidden grid gap-x-8 grid-cols-2 text-white whitespace-nowrap">
          {quizLoggedOutBannerItemsArray.map(
            (item: QuizLoggedOutItems, index) => (
              <Flex className="items-center" key={index}>
                <Icon
                  icon={localizedLoggedOutBannerItems[item].icon}
                  className="w-6 mr-3"
                />
                <H2 cn="text-white lg:text-[16px]">
                  {localizedLoggedOutBannerItems[item].title}
                </H2>
              </Flex>
            ),
          )}
        </Box>
      </Flex>
    </Flex>
  );
};

export default QuizLoggedOutBanner;
